import {
  ACCESS_TOKEN_NAME,
  JSON_CONTENT_TYPE,
} from '../../_constant/constants';
import { ContractPaymentDto } from '../../_dto/_contract/ContractPaymentDto';
import { IApiParams } from '../../_interface/IApiParams';
import { getApi } from '../getApi';

export const apiPaymentContractDoc = async (dto: ContractPaymentDto) => {
  const params: IApiParams = {
    url: '/contract/createPaymentDoc.php',
    headers: {
      'Content-Type': JSON_CONTENT_TYPE,
      'Access-Token': localStorage.getItem(ACCESS_TOKEN_NAME),
    },
  };
  return getApi(params, 'POST', dto);
};
